














import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "ReviewRemoveConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    reviewId: { type: String, required: true },
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
});
